/**
 * Registration Service
 * Handles user registration and login.
 */

const API_BASE = '/api/v1/registration'
const JSON_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
}

export const registrationService = {
  async register(data) {
    const response = await fetch(`${API_BASE}/register`, {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(data),
      credentials: 'include'
    })
    if (!response.ok) {
      const error = await parseJsonResponse(response, 'Registration failed')
      throw new Error(error.detail || 'Registration failed')
    }
    return parseJsonResponse(response, 'Registration failed')
  },

  async login(email, password) {
    const response = await fetch(`${API_BASE}/login`, {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify({ email, password }),
      credentials: 'include'
    })
    if (!response.ok) {
      const error = await parseJsonResponse(response, 'Login failed')
      throw new Error(error.detail || 'Login failed')
    }
    return parseJsonResponse(response, 'Login failed')
  }
}

async function parseJsonResponse(response, fallbackMessage) {
  const contentType = response.headers?.get?.('content-type')?.toLowerCase() || ''
  if (contentType && !contentType.includes('json')) {
    throw unexpectedResponseError(response, fallbackMessage, contentType)
  }

  try {
    return await response.json()
  } catch {
    throw unexpectedResponseError(response, fallbackMessage, contentType)
  }
}

function unexpectedResponseError(response, fallbackMessage, contentType) {
  const isHtml = contentType.includes('html')
  const message = isHtml
    ? `${fallbackMessage}: server returned HTML instead of JSON.`
    : `${fallbackMessage}: server returned an unexpected response.`
  const error = new Error(message)
  error.status = response.status
  return error
}
